import { photo_chunk_upload } from "../api/api";
import { event_msg_keys } from "../eventbus/eventkeys";
import eventBus from "../eventbus/eventbus";
import { imagefile_to_thumbnail_base64, num_to_KM } from "../utils";
import MD5 from 'md5';

export const Status = {
  Idel: 0,
  Uploading: 1,
  Uploadsucc: 2,
  Uploadfail: 3
};

export class Uploader {
  category_id = 0;
  status = Status.Idel;
  file_name = '';
  file_nickname = '';
  file_path = '';
  size = '';
  origionsize = { width: 0, height: 0 };
  origionsize_string = '';
  file = null;
  options = null;
  thumbase64 = '';
  isVideo = false; // 标记是否视频

  constructor(options, category_id) {
    this.options = options;
    this.file = options.file;
    this.file_name = this.file.uid;
    this.size = num_to_KM(this.file.size);
    this.file_nickname = this.file.name;
    this.category_id = category_id;

    // 判断是否是视频
    this.isVideo = this.file.type.startsWith('video/');

    if (this.isVideo) {
      // ===== 视频：跳过图片缩略图生成，直接开始上传 =====
      this.thumbase64 = '';
      // 可选：获取视频宽高（需要的话打开下面注释）
      /*
      this.getVideoSize().then(size => {
        this.origionsize = size
        this.origionsize_string = `${size.width}x${size.height}`
        this.startUpload()
      }).catch(()=>{
        this.origionsize_string = ''
        this.startUpload()
      })
      */
      this.startUpload();
    } else {
      // ===== 图片：原有缩略图逻辑不变 =====
      imagefile_to_thumbnail_base64(this.file)
        .then(result => {
          this.thumbase64 = result.base64;
          this.origionsize = result.origionsize;
          this.origionsize_string = `${this.origionsize.width}x${result.origionsize.height}`;
          this.startUpload();
        })
        .catch(err => {
          this.status = Status.Uploadfail;
          eventBus.emit(event_msg_keys.image_upload_fail, { file_name: this.file_name, err });
          this.destroy();
        });
    }
  }

  async startUpload() {
    if (!this.file || this.status === Status.Uploadfail) return;

    this.status = Status.Uploading;
    const file = this.file;
    // 图片：50KB；视频：500KB
    const chunkSize = this.isVideo ? 500 * 1024 : 50 * 1024;
    const totalChunks = Math.ceil(file.size / chunkSize);

    const fileMd5 = MD5(file.uid + file.size + file.lastModified);

    for (let i = 0; i < totalChunks; i++) {
      if (this.status === Status.Uploadfail) break;

      const start = i * chunkSize;
      const end = Math.min(start + chunkSize, file.size);
      const chunk = file.slice(start, end);

      try {
        const base64 = await this.chunkToBase64(chunk);
        const percent = ((i + 1) / totalChunks).toFixed(2);

        const res = await photo_chunk_upload({
          ctype:this.isVideo?2:1,
          category_id: this.category_id,
          file_ext: file.type.split('/')[1] || (this.isVideo ? 'mp4' : 'jpg'),
          file_nickname: this.file_nickname,
          file_name: this.file_name,
          file_content: base64,
          chunkIndex: i,
          totalChunks,
          fileMd5,
          is_finished: i == totalChunks - 1 ? 1 : 0
        });

        this.file_path = res.file;
        eventBus.emit(event_msg_keys.image_upload_progress, {
          file_name: this.file_name, percent
        });

      } catch (err) {
        this.status = Status.Uploadfail;
        eventBus.emit(event_msg_keys.image_upload_fail, { file_name: this.file_name, err });
        break;
      }
    }

    if (this.status !== Status.Uploadfail) {
      this.status = Status.Uploadsucc;
      eventBus.emit(event_msg_keys.image_upload_success, {
        file_name: this.file_name, file_path: this.file_path
      });
    }
    this.destroy();
  }

  chunkToBase64(chunk) {
    return new Promise((resolve, reject) => {
      const reader = new FileReader();
      reader.readAsDataURL(chunk);
      reader.onload = () => {
        const base64 = reader.result.split(',')[1];
        reader.onload = null;
        reader.onerror = null;
        resolve(base64);
      };
      reader.onerror = (err) => {
        reader.onload = null;
        reader.onerror = null;
        reject(err);
      };
    });
  }

  // 【可选】获取视频宽高，需要就启用，constructor里面打开注释即可
  getVideoSize() {
    return new Promise((resolve, reject) => {
      const video = document.createElement('video');
      video.src = URL.createObjectURL(this.file);
      video.onloadedmetadata = () => {
        resolve({ width: video.videoWidth, height: video.videoHeight });
        URL.revokeObjectURL(video.src);
      }
      video.onerror = reject;
    })
  }

  destroy() {
    this.file = null;
    this.options = null;
    this.origionsize = null;
    this.formData = null;
  }
}